import React from 'react'
import './Slider.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import { Pagination, Navigation,Autoplay } from "swiper";
import "swiper/css/pagination";
import "swiper/css/navigation";
import photo from "../../../assets/Photo"
const Slider=()=> {

  
  return (
    <div>
         <div className='Sliders'>
         <Swiper
        pagination={{
          type: "fraction",
          
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        
        navigation={true}
        modules={[Pagination, Navigation,Autoplay]}
        
      >
        {
        photo.slice(4,7).map((item,index)=>{
          return(
             <SwiperSlide> <div className='Slide'>
      <div className='Slide__infos'>
        <h5 className='Slide__infos-content'>O’zMU va Gong-Kong universiteti hamkorligi</h5>
       <button className='Slide__infos-button'>Batafsil ko'rish</button>
      
      </div>
      
      <div className='Slide__img'><img src={item.imgurl} alt="Slid img" /></div>
    </div></SwiperSlide>
          )
        })
        }
       
   
        
      </Swiper>
   
    
  </div>
   </div>
  )
}

export default Slider